import { createContext } from "react";

import { useKnowledgeBaseProvider } from "./hooks/useKnowledgeBaseProvider";
import { KnowledgeBaseContextType } from "./types";

export const KnowledgeBaseContext = createContext<
  KnowledgeBaseContextType | undefined
>(undefined);

export const KnowledgeBaseProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => {
  const knowledgeBaseProviderUtils = useKnowledgeBaseProvider();

  return (
    <KnowledgeBaseContext.Provider value={knowledgeBaseProviderUtils}>
      {children}
    </KnowledgeBaseContext.Provider>
  );
};
